import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import preview from '@/shared/assets/images/DentalPhotosPreview.png';
import { useMedia } from '@/shared/hooks';

import { useDentalPhotoReportCard } from '../../hooks';
import { PhotoCollage } from '../PhotoCollage/PhotoCollage';

import styles from './DentalPhotoReportCard.module.scss';

type DentalPhotoReportCardProps = {
  patientID: string;
  elementID?: string;
  className?: string;
  testID?: string;
};

export const DentalPhotoReportCard: FC<DentalPhotoReportCardProps> = (
  props,
) => {
  const { className, testID, patientID, elementID } = props;
  const { formatMessage, formatDate } = useIntl();
  const { isMobile } = useMedia();

  const { photos, lastUploadDate, hasPhotos, handleCardClick } =
    useDentalPhotoReportCard(patientID);

  return (
    <div
      id={elementID}
      data-testid={testID}
      data-component="dental-photo-report-card"
      className={cn(styles.container, className)}
      onClick={handleCardClick}
    >
      <h4 className={cn(styles.title, isMobile ? 'h2m' : 'h4')}>
        {formatMessage({
          id: 'studyUpload.DentalPhotos',
          defaultMessage: 'Dental Photos',
        })}
      </h4>

      {lastUploadDate && (
        <h5 className={cn(styles.uploadDate, isMobile ? 'p2m' : 'h7')}>
          {formatDate(lastUploadDate, { dateStyle: 'medium' })}
        </h5>
      )}

      <div className={styles.innerContainer}>
        {hasPhotos ? (
          <PhotoCollage photoIDs={photos} className={styles.collage} />
        ) : (
          <img
            className={styles.overlay}
            alt={formatMessage({
              id: 'dentalPhotos.widget.preview.altText',
              defaultMessage: 'Dental photo preview',
            })}
            src={preview}
          />
        )}
      </div>
    </div>
  );
};
